"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VirtualMenuList = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactWindow = require("react-window");
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenUtils = require("@8x8/oxygen-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // @ts-check
var VirtualMenuList = function VirtualMenuList(_ref) {
  var children = _ref.children,
    maxHeight = _ref.maxHeight,
    getValue = _ref.getValue,
    theme = _ref.theme;
  /**
   * lineHeight: 1.5rem
   * optionPaddingVertical: 8px
   *
   * need to transform to numbers to calculate the height
   */
  var rowHeight = (0, _oxygenUtils.useFontSize)(parseFloat(theme.lineHeight)) + parseFloat(theme.optionPaddingVertical) * 2;
  var _getValue = getValue(),
    _getValue2 = _slicedToArray(_getValue, 1),
    value = _getValue2[0];

  // flatten children to have a non-nested array
  // add the group item as an element and then the group options/children
  var flatChildren = _react["default"].Children.toArray(children).flatMap(function (item) {
    if (! /*#__PURE__*/_react["default"].isValidElement(item)) {
      return item;
    }

    // for length > 1 we have multiple children
    if (_react["default"].Children.toArray(item.props.children).length > 1) {
      return [/*#__PURE__*/_react["default"].cloneElement(item, {
        children: null
      })].concat(_toConsumableArray(item.props.children));
    }
    return item;
  });

  // index * rowHeight = offset
  var initialOffset = flatChildren.findIndex(function (item) {
    if (!item.props) return false;
    if (!item.props.value) return false;
    return item.props.value === (value === null || value === void 0 ? void 0 : value.value);
  }) * rowHeight;
  return /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
    height: maxHeight,
    width: "100%",
    itemCount: flatChildren.length,
    itemSize: rowHeight,
    initialScrollOffset: initialOffset
  }, function (_ref2) {
    var index = _ref2.index,
      style = _ref2.style;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style
    }, flatChildren[index]);
  });
};
exports.VirtualMenuList = VirtualMenuList;
VirtualMenuList.propTypes = {
  theme: _propTypes["default"].shape({
    optionPaddingVertical: _propTypes["default"].string,
    lineHeight: _propTypes["default"].string
  }).isRequired,
  children: _propTypes["default"].node.isRequired,
  maxHeight: _propTypes["default"].number.isRequired,
  getValue: _propTypes["default"].func.isRequired
};
var _default = (0, _oxygenConfig.withTheme)(VirtualMenuList, 'select');
exports["default"] = _default;